import { useEffect, useState } from "react";
import styled from "styled-components";
import logo from "../assets/img/logo-engS1.svg";
import user from "../assets/img/header/user.svg";
import cartGary from "../assets/img/header/ShoppingCartGray.svg";
import cartRed from "../assets/img/header/ShoppingCartRed.svg";
import hamburger from "../assets/img/hamburger.svg";
import logout from "../assets/img/header/logout-icon.svg";
import { Button, Text } from "../common/UI";
import Search from "../components/Search";
import { useTranslation } from "react-i18next";
import { isMobileDevice, isTabletDevice } from "../utils/device";
import { useLocation, useNavigate } from "react-router-dom";
import { observer, inject } from "mobx-react";
import theme from "../theme";
import SideBar from "../components/DeliveryOrder/SideBar";

const SidebarOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 75%;
  height: 100%;
  background: #be1e2c;
  z-index: 999;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease-in-out;
  transform: ${(props) => (props.open ? "translateX(0)" : "translateX(100%)")};
  display: flex;
  flex-direction: column;
  padding: 20px;
  color: white;
`;

const CloseButton = styled.button`
  align-self: flex-start;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
`;

const Heaeder = styled.div`
  padding: ${(p) =>
    p.location.pathname.match("/delivery_order/frameList") ||
    p.location.pathname.match("/delivery_order/ordersList") ||
    p.location.pathname.match("/delivery_order/frame_order_item") ||
    p.location.pathname.match("/delivery_order/cart") ||
    p.location.pathname.match("/delivery_order/login") ||
    p.location.pathname.match("/delivery_order/frame_order_details")
      ? "0"
      : "20px 0px"};
  display: ${(p) => (p.postLogin ? (p.isMobile ? "block" : "grid") : "block")};
  visibility: ${(p) =>
    (p.location.pathname.match("/delivery_order/frameList") ||
      p.location.pathname.match("/delivery_order/ordersList") ||
      p.location.pathname.match("/delivery_order/frame_order_item") ||
      p.location.pathname.match("/delivery_order/cart") ||
      p.location.pathname.match("/delivery_order/frame_order_details")) &&
    "hidden"};
  max-width: ${(p) => (p.isMobile ? "100vw" : "91vw")};
  min-width: ${(p) => (p.isMobile ? "100vw" : "74vw")};
  margin: 0 auto;
  grid-template-columns: ${(p) =>
    p.isMobile
      ? p.postLogin
        ? "repeat(3, auto)"
        : "repeat(1, auto)"
      : p.postLogin
        ? "repeat(3, auto)"
        : "repeat(1, auto)"};
  gap: ${(p) => (p.isMobile ? "5px" : 0)};
  justify-content: ${(p) => (p.postLogin ? "unset" : "center")};
  justify-items: center;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;

  img {
    max-width: 207px;
  }

  @media (max-width: 1000px) {
    width: 100%;

    img {
      max-width: 164px;
    }
  }
`;

const MenuIcons = styled.a``;

const Header = ({ onSearch, isRtl, userStore, productsStore }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const isTablet = isTabletDevice();
  const isMobile = isMobileDevice();
  const onMobile = isTablet || isMobile;
  const { t } = useTranslation("header");
  const location = useLocation();
  const navigate = useNavigate();
  const [isProjectOrder, setIsProjectOrder] = useState(!!userStore.selectedProject?.DOCNO);

  const logoOnClick = () => {
    // clear store
    productsStore.setActiveCategory("");
    productsStore.setActiveItem("");
    productsStore.clearSearch();
    navigate("/");
  };

  const [inCart, setInCart] = useState(
    Object.values(productsStore.cart)
      ?.flat(1)
      .reduce((accumulator, object) => {
        return accumulator + (object.quantity || 0);
      }, 0)
  );

  useEffect(() => {
    setIsProjectOrder(!!userStore.selectedProject?.DOCNO);
  }, [userStore.selectedProject]);

  useEffect(() => {
    if (isProjectOrder) return;

    setInCart(
      Object.values(productsStore.cart)
        ?.flat(1)
        .reduce((accumulator, object) => {
          return accumulator + (object.quantity || 0);
        }, 0)
    );
  }, [productsStore.cart, isProjectOrder]);

  useEffect(() => {
    if (!isProjectOrder) return;
    const totalQuantity = Object.keys(productsStore.projectCartProducts).reduce((sum, key) => {
      const items = Object.values(productsStore.projectCartProducts[key]).flat();
      const keyTotal = items.reduce((subSum, item) => subSum + (item.quantity || 0), 0);
      return sum + keyTotal;
    }, 0);
    setInCart(totalQuantity);
  }, [productsStore.projectCartProducts, isProjectOrder]);

  return (
    <Heaeder postLogin={userStore.isAuthenticated} isMobile={onMobile} location={location}>
      {!!onMobile && location.pathname.match("/delivery_order/main") && (
        <div
          style={{
            display: "flex",
            position: "relative",
            alignItems: "center",
            width: "100%",
            gap: 4,
          }}
        >
          <div
            onClick={() => setIsSidebarOpen(true)}
            style={{
              width: "auto",
              visibility: !userStore.isAppAuthenticated && "hidden",
              paddingInlineStart: 35,
            }}
          >
            <img
              src={hamburger}
              alt="hamburger"
              style={{
                verticalAlign: "middle",
              }}
            />
          </div>
          <div
            onClick={logoOnClick}
            style={{
              width: "fit-content",
              position: "absolute",
              right: "50%",
              transform: "translateX(50%)",
            }}
          >
            <img
              src={logo}
              alt="logo"
              style={{
                maxWidth: 128,
                margin: "auto",
                marginInlineEnd: onMobile ? 0 : 113,
              }}
            />
          </div>
        </div>
      )}
      {onMobile && location.pathname.match("/delivery_order/login") && (
        <div
          style={{
            display: "flex",
            position: "relative",
            alignItems: "center",
            width: "100%",
            gap: 4,
            height: 70,
          }}
        >
          <div
            style={{
              width: "fit-content",
              position: "absolute",
              right: "50%",
              transform: "translateX(50%)",
            }}
          >
            <img
              src={logo}
              alt="logo"
              style={{
                maxWidth: 128,
                margin: "auto",
                marginInlineEnd: onMobile ? 0 : 113,
              }}
            />
          </div>
        </div>
      )}
      {onMobile &&
        !location.pathname.match("/register") &&
        !location.pathname.match("/delivery_order") &&
        !location.pathname.match("/registrationComplete") &&
        !location.pathname.match("/login") && (
          <a href="/" style={{ width: "90px" }}>
            <img
              src={hamburger}
              alt="hamburger"
              style={{
                verticalAlign: "middle",
              }}
            />
          </a>
        )}
      {!isMobile && !isTablet && (
        <div onClick={logoOnClick} style={{ width: "fit-content", cursor: "pointer" }}>
          <img
            src={logo}
            alt="logo"
            style={{
              maxWidth: userStore.isAuthenticated ? "164px" : "207px",
              margin: "auto",
              marginInlineEnd: onMobile ? 0 : 113,
            }}
          />
        </div>
      )}
      {userStore.isAuthenticated &&
        !location.pathname.match("/register") &&
        !location.pathname.match("/delivery_order") &&
        !location.pathname.match("/registrationComplete") &&
        !location.pathname.match("/login") && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 30,
            }}
          >
            <div>{!isMobile && !isTablet && <Search onSearch={onSearch} isRtl={isRtl} />}</div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 5,
                width: 180,
              }}
            >
              <Text style={{ textAlign: "start", fontSize: 16, fontWeight: 500 }}>
                {`${t("hello")}, ${userStore.userDetails.FULLNAME}`}
              </Text>
              {!!isProjectOrder ? (
                <Text style={{ textAlign: "start" }}>
                  {`${t("project_order")} ${userStore.selectedProject?.PROJDES}`}
                </Text>
              ) : (
                <Text style={{ textAlign: "start" }}>{userStore.userDetails.CUSTDES}</Text>
              )}
            </div>
            <div style={{ margin: "auto" }}>
              {!isMobile && !isTablet ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 28,
                  }}
                >
                  <Button
                    onClick={() => navigate("/my-orders")}
                    style={{
                      fontSize: 12,
                      width: "auto",
                      height: "2.6rem",
                      lineHeight: "0.2rem",
                      fontWeight: "bold",
                      textWrap: "nowrap",
                    }}
                  >
                    {t("customer_portal")}
                  </Button>
                  <MenuIcons style={{ marginBottom: inCart > 0 ? 20 : 5 }}>
                    {inCart > 0 && (
                      <span
                        style={{
                          position: "relative",
                          top: 10,
                          right: -10,
                          width: 20,
                          height: 20,
                          borderRadius: 50,
                          backgroundColor: theme.color.red,
                          color: theme.color.white,
                          fontSize: 11,
                          fontWeight: 900,
                          display: "flex",
                          textAlign: "center",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {inCart}
                      </span>
                    )}
                    <img
                      src={inCart > 0 ? cartRed : cartGary}
                      alt="cart"
                      title="cart"
                      style={{
                        verticalAlign: "middle",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate("/cart")}
                    />
                  </MenuIcons>
                  <img
                    src={logout}
                    title="logout"
                    alt="logout"
                    onClick={userStore.logout}
                    style={{
                      verticalAlign: "middle",
                      width: 16,
                      cursor: "pointer",
                    }}
                  />
                </div>
              ) : (
                <>
                  <MenuIcons href="/">
                    <img
                      src={user}
                      alt="user"
                      title="user"
                      style={{
                        verticalAlign: "middle",
                      }}
                    />
                  </MenuIcons>
                  <MenuIcons href="/">
                    <img
                      src={inCart > 0 ? cartRed : cartGary}
                      alt="cart"
                      title="cart"
                      style={{
                        verticalAlign: "middle",
                      }}
                    />
                  </MenuIcons>
                </>
              )}
            </div>
          </div>
        )}
      {onMobile && (
        <SidebarOverlay open={isSidebarOpen}>
          <CloseButton onClick={() => setIsSidebarOpen(false)}>×</CloseButton>
          <SideBar onClose={() => setIsSidebarOpen(false)} />
        </SidebarOverlay>
      )}
    </Heaeder>
  );
};

export default inject("userStore", "productsStore")(observer(Header));
